import { useQuery } from '@tanstack/react-query'
import { usersApi } from '@/lib/api'
import type { Entitlements } from '@/types'

/** Effective plan + quota usage for the current user. Source of truth for the
 *  UI gates (quota counter, PDF/review buttons). */
export function useEntitlements() {
  return useQuery<Entitlements>({
    queryKey: ['entitlements'],
    queryFn: () => usersApi.getEntitlements(),
    staleTime: 60_000,
  })
}
